<template>
    <b-badge pill v-if="badgeVariant" :variant="badgeVariant" :style="{ fontSize: `${badgeSize}rem` }">
        {{ value }}
    </b-badge>
    <span v-else></span>
</template>

<script>
    export default {
        computed: {
            badgeVariant() {
                return this.params.badgeVariant(this.params);
            },
        },
        data() {
            return {
                value: null,
            };
        },
        created() {
            this.value = this.params.value;
            this.badgeSize = 0.9;
        },
    };
</script>

<style lang="scss" scoped></style>
